import type { ReactNode } from "react";
import { PageSkeleton } from "@/components/page-skeleton";

// Ported from connect-v2's PageContainer + Heading, without the info sidebar.
// 16 px side padding on phones (brief), wider on desktop.
export function PageContainer({
	title,
	description,
	action,
	loading = false,
	children,
}: {
	title: string;
	description?: string;
	action?: ReactNode;
	loading?: boolean;
	children: ReactNode;
}) {
	if (loading) return <PageSkeleton />;

	return (
		<div className="flex min-w-0 flex-1 flex-col px-4 py-4 md:px-6">
			<div className="mb-4 flex flex-col gap-2 sm:flex-row sm:items-start sm:justify-between">
				<div>
					<h1 className="text-2xl font-bold tracking-tight sm:text-3xl">{title}</h1>
					{description && <p className="text-muted-foreground text-sm">{description}</p>}
				</div>
				{action && <div className="shrink-0">{action}</div>}
			</div>
			{children}
		</div>
	);
}
